import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { showAlert } from 'actions/common/alert';
import { downloadQuotation } from 'actions/orderAggregators/quotation';
import { downloadReceipt } from 'actions/mypage/receipt';
import Preview from 'components/Preview';

const mapStateToProps = ({
  ...orderAggregatorsQuotation,
  mypageReceipt: { url, error },
}) => ({
  ...orderAggregatorsQuotation,
  mypageReceipt: { url },
  error
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      push,
      showAlert,
      downloadQuotation,
      downloadReceipt
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Preview);



// WEBPACK FOOTER //
// ./src/containers/Preview/index.js